import { F0Box } from '@factorialco/f0-react'
import { Cross } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import SalaryIndicator from 'modules/job_catalog/benchmark/components/SalaryIndicator'
import { MarketPosition } from 'modules/job_catalog/benchmark/types'

const getPositionLabel = (position: MarketPosition): string => {
  switch (position) {
    case 'below':
      return i18n.t('job_catalog.benchmark.market_position.below')
    case 'at_market':
      return i18n.t('job_catalog.benchmark.market_position.at_market')
    case 'above':
      return i18n.t('job_catalog.benchmark.market_position.above')
    default:
      return i18n.t('job_catalog.benchmark.market_position.unknown')
  }
}

const getBadgeLabel = (position: MarketPosition, delta?: number | null): string => {
  if (delta != null && position === 'below') {
    return i18n.t('job_catalog.benchmark.market_position.below_delta', { delta })
  }
  if (delta != null && position === 'above') {
    return i18n.t('job_catalog.benchmark.market_position.above_delta', { delta })
  }
  return getPositionLabel(position)
}

const getBadgeColor = (position: MarketPosition): string => {
  switch (position) {
    case 'below':
      return 'hsl(var(--warning-50))'
    case 'at_market':
      return 'hsl(var(--positive-50))'
    case 'above':
      return 'hsl(var(--info-50))'
    default:
      return 'hsl(var(--neutral-solid-50))'
  }
}

interface Props {
  position: MarketPosition
  marketDelta?: number | null
  title?: string
  onClose: () => void
}

const SalaryPopoverHeader = ({ position, marketDelta, title, onClose }: Props) => {
  return (
    // eslint-disable-next-line factorial/no-raw-html -- Exact pixel sizing not available via F0Box tokens
    <div
      style={{
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        height: 63,
        paddingLeft: 12,
        paddingRight: 8,
        paddingTop: 8,
        boxSizing: 'border-box',
      }}
    >
      <F0Box display="flex" flexDirection="row" alignItems="center" gap="xs">
        <SalaryIndicator position={position} size="sm" />
        {/* eslint-disable-next-line factorial/no-raw-html -- F0Text style prop is blocked; 14px/500 not available as a variant */}
        <span style={{ color: getBadgeColor(position), fontWeight: 500, fontSize: 14 }}>
          {title ?? getBadgeLabel(position, marketDelta)}
        </span>
      </F0Box>

      {/* eslint-disable-next-line factorial/no-raw-html -- Exact 24x24 / 16x16 icon sizing not available via F0Button */}
      <button
        type="button"
        aria-label={i18n.t('common.close')}
        onClick={onClose}
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: 24,
          height: 24,
          padding: 0,
          border: 'none',
          background: 'transparent',
          borderRadius: 9999,
          cursor: 'pointer',
        }}
      >
        <Cross width={16} height={16} />
      </button>
    </div>
  )
}

export default SalaryPopoverHeader
